import { ArrowRightAlt } from "@mui/icons-material";
import { Divider, Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import { tokens } from "../../../store/tokens";

const Stat = ({ label, value }) => {
  const isUp = Number(value) >= 100;
  return (
    <Stack spacing={0.5} sx={{ flex: 1 }}>
      <Typography
        variant="subtitle2"
        sx={{ color: tokens.color.inkMuted, fontWeight: 600 }}
      >
        {label}
      </Typography>
      <Stack direction={"row"} alignItems={"center"} spacing={0.25}>
        <Typography variant="h6" sx={{ color: tokens.color.ink }}>
          {value}
        </Typography>
        <ArrowRightAlt
          sx={{
            fontSize: "1.1rem",
            transform: isUp ? "rotate(-90deg)" : "rotate(90deg)",
            color: isUp ? tokens.color.success : tokens.color.error,
          }}
        />
      </Stack>
    </Stack>
  );
};

const PageReach = (props) => {
  const { profileDetails } = props;
  const { follower, visitor } = profileDetails;

  return (
    <Paper
      elevation={0}
      sx={{
        padding: `${tokens.card.padding.md}px`,
        borderRadius: `${tokens.card.radius}px`,
        border: `1px solid ${tokens.color.line}`,
        bgcolor: tokens.color.surface,
      }}
    >
      <Stack direction="row" alignItems="stretch" spacing={2}>
        <Stat label="Audience" value={visitor} />
        <Divider orientation="vertical" flexItem sx={{ borderColor: tokens.color.line }} />
        <Stat label="Follower" value={follower} />
      </Stack>
    </Paper>
  );
};

export default PageReach;
